import {
    clearSsoCallbackResponseFromUrl,
    shouldEnterSsoCallback,
} from "./ssoCallbackBootstrap.helpers";
import { BOOT_FAILURE_MESSAGE } from "./bootFailure.helpers";

const reportBootFailure = (error: unknown) => {
    // eslint-disable-next-line no-console
    console.error("[boot] failed to load application chunk", error);

    const root = document.getElementById("root");

    if (root) {
        root.textContent = BOOT_FAILURE_MESSAGE;
    }
};

const reportSsoCallbackBootFailure = (error: unknown) => {
    clearSsoCallbackResponseFromUrl();
    reportBootFailure(error);
};

if (shouldEnterSsoCallback(window.location.pathname)) {
    import("./ssoCallbackBootstrap")
        .then(({ runSsoCallbackBootstrap }) => runSsoCallbackBootstrap())
        .catch(reportSsoCallbackBootFailure);
} else {
    import("./bootstrapApp").then(({ bootstrapApp }) => bootstrapApp()).catch(reportBootFailure);
}
